import React from 'react';

// Loads Daum Postcode SDK once and caches. Returns a promise that resolves
// when window.daum.Postcode is available.
let _postcodeLoader = null;
const loadPostcodeScript = () => {
  if (typeof window === 'undefined') return Promise.reject(new Error('no window'));
  if (window.daum && window.daum.Postcode) return Promise.resolve();
  if (_postcodeLoader) return _postcodeLoader;
  _postcodeLoader = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => { _postcodeLoader = null; reject(new Error('postcode load failed')); };
    document.head.appendChild(s);
  });
  return _postcodeLoader;
};

/**
 * Reusable Daum(Kakao) 우편번호 검색 버튼.
 *
 * Props:
 *   onComplete({ postal_code, road_address, jibun_address, base_address, extra_address })
 *   detailInputRef — optional ref to the "상세 주소" input so we can focus it after search
 *   className, label, testId
 */
const AddressSearch = ({ onComplete, detailInputRef, className = '', label = '주소검색', testId = 'address-search-btn' }) => {
  const openSearch = async () => {
    try {
      await loadPostcodeScript();
    } catch (e) {
      alert('주소검색을 불러올 수 없습니다. 네트워크 상태를 확인해주세요.');
      return;
    }
    new window.daum.Postcode({
      oncomplete: (data) => {
        const road = data.roadAddress || '';
        const jibun = data.jibunAddress || data.autoJibunAddress || '';
        // If user picked the road-address ("R") tab, base=도로명 else 지번.
        const base = data.userSelectedType === 'J' ? (jibun || road) : (road || jibun);
        let extra = '';
        if (data.userSelectedType === 'R') {
          if (data.bname && /[동|로|가]$/.test(data.bname)) extra += data.bname;
          if (data.buildingName) extra += (extra ? ', ' : '') + data.buildingName;
          if (extra) extra = `(${extra})`;
        }
        onComplete?.({
          postal_code: data.zonecode || '',
          road_address: road,
          jibun_address: jibun,
          base_address: base,
          extra_address: extra,
        });
        // Focus the "상세 주소" input for the very next keystroke.
        setTimeout(() => { try { detailInputRef?.current?.focus(); } catch {} }, 0);
      },
    }).open();
  };
  return (
    <button type="button" onClick={openSearch}
      className={className || 'px-3 py-2 rounded-lg bg-black text-white text-xs font-bold whitespace-nowrap hover:bg-[#FF3B30] transition-colors'}
      data-testid={testId}>
      {label}
    </button>
  );
};

export default AddressSearch;
